import React                from 'react';
import PropTypes            from 'prop-types';
import Flux                 from '../../../flux/Flux';
import {VXPay, VXPayAction} from '../../../utils/VXPay';
import { getCommonTranslation } from '../../../utils/TranslationHelper';
import VXButtonOutline             from "../../SimpleElements/VXButton/Presets/VXButtonOutline";
import {VXButtonLineConfig}        from "../../SimpleElements/VXButton/VXButtonConfig";

class ActorProfileFeedLike extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isFavorite: this.props.isFavorite,
		};

		this.onActorAdded    = this.onActorAdded.bind(this);
		this.onActorRemoved  = this.onActorRemoved.bind(this);
		this.onButtonClicked = this.onButtonClicked.bind(this);
		this.togglePin       = this.togglePin.bind(this);
	}

	componentDidMount() {
		Flux.Favorite.addActorPinnedListener(this.onActorAdded);
		Flux.Favorite.addActorUnpinnedListener(this.onActorRemoved);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.isFavorite !== this.props.isFavorite) {
			this.setState({
				isFavorite: nextProps.isFavorite,
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (this.props.actorId !== nextProps.actorId || this.props.isFavorite !== nextProps.isFavorite || this.state.isFavorite !== nextState.isFavorite);
	}

	componentWillUnmount() {
		Flux.Favorite.removeActorPinnedListener(this.onActorAdded);
		Flux.Favorite.removeActorUnpinnedListener(this.onActorRemoved);
	}

	onActorAdded(actorId) {
		if (actorId === this.props.actorId) {
			this.setState({
				isFavorite: true,
			});
		}
	}

	onActorRemoved(actorId) {
		if (actorId === this.props.actorId) {
			this.setState({
				isFavorite: false,
			});
		}
	}

	togglePin() {
		if (this.state.isFavorite) {
			Flux.Favorite.unpinActor(this.props.actorId);
		} else {
			Flux.Favorite.pinActor(this.props.actorId);
		}
		this.setState({
			isFavorite: !this.state.isFavorite,
		});
	}

	onButtonClicked(e) {
		if (!Flux.Guest.isLoggedIn()) {
			const action = new VXPayAction(Flux.Constants.ActionTypes.Notification.FAVORITE_PIN_ACTOR, {
				targetId: this.props.actorId,
			});
			VXPay.openSignupOrLogin({
				host: this.props.actorId,
			}, action);
		} else {
			this.togglePin();
		}
		if (e.preventDefault) {
			e.preventDefault();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
	}

	render() {
		if (!this.props.actorId) {
			return null;
		}
		return (
			<div className='profile-feed__button profile-feed__button--heart'>
            <VXButtonOutline staticMode={true} line1={[new VXButtonLineConfig(this.state.isFavorite ? getCommonTranslation('you-follow') + " " + this.props.actorName : this.props.actorName + " " + getCommonTranslation('follow'))]} onClick={this.onButtonClicked} icon={this.state.isFavorite ? "-icon-heart-full" : "-icon-heart-line" } />
          </div>
		);
	}

}

ActorProfileFeedLike.propTypes = {
	actorId:    PropTypes.number.isRequired,
    actorName:  PropTypes.string.isRequired,
	isFavorite: PropTypes.bool.isRequired,
};

export default ActorProfileFeedLike;
